<template>
    <div class="style-el-main" ref="homePage">

        <!-- 主容器 -->
        <el-container>

            <!-- 顶栏容器 -->
            <el-header class="homeHeader">
                <div class="title">
                    <img style="vertical-align: middle; height: 38px;" :src="require('@/assets/img/' + _p_env.VUE_APP_RES_IMG_LOGO)" />
                    <span v-if="isMchSys" style="vertical-align: middle; height: 50px; margin-left: 30px;">{{_p_env.VUE_APP_APP_NAME2}}</span>
                    <!-- 商户标题 -->
                    <span v-else style="vertical-align: middle; height: 50px; margin-left: 5px;">{{_p_env.VUE_APP_APP_NAME}}</span>
                    <!-- 管理标题 -->
                </div>

                <div v-if="isMchSys">
                    <el-menu
                            :default-active="activeIndex2"
                            class="el-menu-demo"
                            mode="horizontal"
                            @select="handleSelect"
                            background-color="#4a5064"
                            text-color="#fff"
                            active-text-color="#ffd04b">
                        <el-menu-item index="1">首页</el-menu-item>
                        <!--
                        <el-menu-item index="2">对账单</el-menu-item>
                        <el-menu-item index="2">收款单</el-menu-item>
                        -->
                        <el-submenu index="2">
                            <template slot="title">收款单</template>
                            <el-menu-item index="2-1">普通收款单</el-menu-item>
                            <el-menu-item index="2-2">固定收款单</el-menu-item>
                        </el-submenu>
                        <el-submenu index="3">
                            <template slot="title">交易信息</template>
                            <el-menu-item index="3-1">交易明细</el-menu-item>
                            <el-menu-item index="3-2">交易汇总</el-menu-item>
                        </el-submenu>
                        <el-submenu index="4">
                            <template slot="title">系统管理</template>
                            <el-menu-item index="4-1">商户信息</el-menu-item>
                            <el-menu-item index="4-2">个人中心</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>

                <div>
                    <el-button icon="el-icon-bell" type="text" style="margin-right: 8px;color: #FFFFFF;" size="normal"
                               @click="goChat"></el-button>
                    <el-dropdown class="userInfo" @command="commandHandler">
                        <span class="el-dropdown-link" v-if="isMchSys">
                            {{user.name}}<span><img :src="user.userface?user.userface:require( '@/assets/img/' + _p_env.VUE_APP_RES_IMG_DEF_USER_FACE)" :onerror="defaultUserFace" alt=""></span>
                        </span>
                        <span class="el-dropdown-link" v-else>
                            {{user.agentName}}-{{user.name}}<span><img :src="user.userface?user.userface:require( '@/assets/img/' + _p_env.VUE_APP_RES_IMG_DEF_USER_FACE)" :onerror="defaultUserFace" alt=""></span>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="userinfo" v-if="!isMchSys">个人中心</el-dropdown-item>
                            <!--
                            <el-dropdown-item command="setting" v-if="!isMchSys">设置</el-dropdown-item>
                            -->
                            <el-dropdown-item command="logout" divided v-if="!isMchSys">注销登录</el-dropdown-item>
                            <el-dropdown-item command="logout" v-else>注销登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>

            <!-- 子容器 -->

            <el-container v-if="isMchSys"> <!-- 商户欢迎页面 -->
                <div v-if="isMchSysFirstOpen">
                    <img src="@/assets/img/login-t3.png"
                         style="width: 100%; height: 100%; margin-top: -60px; z-index:1; position:absolute; "/>
                    <img :src="require('@/assets/img/' + this._p_env.VUE_APP_RES_IMG_MCH_HOME_CENTER_BG)"
                         style="width: auto; height: auto; left:50%; margin-left: -392px; top:30%; z-index:2; position:absolute; "/>

                    <!--
                    <div style="position:absolute; z-index:3; width: 250px; left: 5px; bottom: 5px;font-size: 10px; color: gray">
                        <div><span>账号：827320148120022</span></div>
                        <div><span>登录时间：2020-06-09 22:35:57</span></div>
                        <div><span>登录IP：{{returnCitySN.cip}}</span></div>
                    </div>
                    -->

                </div>
                <el-main v-else style="display: flex; flex-flow: column; min-width: 800px;
                padding: 5px 10px 5px; overflow: hidden; background-color: #EEF0F3;">
                    <keep-alive exclude="" v-if="isRefresh">
                        <router-view class="homeRouterView" style="flex: 1 ;overflow: hidden; "/>
                    </keep-alive>
                </el-main>
            </el-container>
            <el-container v-else ref="asideScrollbar"> <!-- 管理欢迎页面 -->
                <!-- 侧边栏容器 -->
                <el-aside :width="isCollapse?'64px':'200px'"
                          style="
                                display: block;">
                    <el-scrollbar style="background-color:#333744">
                        <!-- 【router】   是否使用 vue-router 的模式，启用该模式会在激活导航时以 index 作为 path 进行路由跳转 -->
                        <el-menu
                                :collapse="isCollapse"
                                :router="false"
                                unique-opened
                                @select="handleSelect2"
                                ref="refElMenu">
                            <el-submenu :index="index+''" v-for="(item,index) in routes" v-if="!item.hidden"
                                        :key="index">
                                <template slot="title">
                                    <i style="color: #ffffff;margin-right: 5px" :class="item.iconCls + ' fa-fw'"></i>
                                    <span style="font-size: 14px;">{{item.name}}</span>
                                </template>
                                <el-menu-item :index="child.path" v-for="(child,indexj) in item.children" :key="indexj">

                                    <span style="font-size: 13px;"><i style="color: #409eff;margin-right: 5px" :class="child.iconCls + ' fa-fw'"></i>{{child.name}}</span>
                                </el-menu-item>
                            </el-submenu>
                        </el-menu>
                    </el-scrollbar>
                </el-aside>

                <!-- 主要区域容器 style="background: #f3f3f3;" -->
                <el-main style="display: flex; flex-flow: column; min-width: 800px;
                padding: 5px 10px 5px; overflow: hidden; background-color: #EEF0F3;"
                         :style="{'left' : '200px'}"> <!-- background-color: #EEF0F3; -->

                    <div class="yx-flex-h-start">
                        <div class="style-collapse" @click="onCollapse">
                            <i :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i>
                        </div>
                        <div style="width: 100%;">
                            <el-tabs type="card" class="cls-tab"
                                     v-model="activeTab"
                                     @tab-click="clickTab"
                                     @tab-remove="removeTab">
                                <el-tab-pane
                                        v-for="(item, index) in menuTabs"
                                        :key="item.name"
                                        :label="item.title"
                                        :name="item.name"
                                        :closable="item.name!=='/home'">
                            <span slot="label">
                                <i :class="item.icon" />
                                {{item.title}}
                            </span>
                                </el-tab-pane>
                            </el-tabs>

                        </div>
                    </div>

                    <!-- class="homeWelcome"
                    <div v-if="this.$router.currentRoute.path=='/home'">
                        v1.0.0.200321.18_release
                        <img src="../../static/img/login-t3.png"
                             style="width: 100%; height: 100%; margin-top: -10px; margin-left: -198px; z-index:1; position:absolute; "/>
                    </div>
                    -->

                    <div style="overflow-y: auto;height: 100%; display: flex; flex-direction: column;" v-if="this.$router.currentRoute.path=='/home'">
                        <Analysis></Analysis>

                        <div style="display: flex; flex: 1; align-items: flex-end; justify-content: center; ">
                            <span class="font10-c">Copyright ©2021 南京中研信息科技有限公司 ALL RIGHTS RESERVED.</span>
                        </div>
                    </div>


                    <!--
                        include 使该标签作用于所有name属性的值跟此标签 include的属性值一致的vue页面
                        exclude 使该标签不作用于所有name属性的值跟此标签 exclude的属性值一致的vue页面
                        示例： exclude="DevInfo"
                    -->
                    <keep-alive exclude="" v-if="isRefresh">
                        <router-view class="homeRouterView" style="flex: 1 ;overflow: hidden; "/>
                    </keep-alive>


                </el-main>
            </el-container>

        </el-container>
    </div>
</template>

<script>
    import {URL_DATA_MCH_BUSINESSCATEGORY, URL_DATA_USER_BASE_PRORATE, URL_DEV_MODELS} from "../utils/cons";
    import {MiniRate} from "../utils/MiniRate";
    import Analysis from "../components/dashboard/Analysis";

    const HOME_TAB = '/home'
    const USER_TAB = '/hrinfo'

    export default {
        name: "Home",
        components: {
            Analysis,
            'remote-js': { // 搜狐接口获取本地外网IP
                render(createElement) {
                    return createElement('script', {attrs: {type: 'text/javascript', src: this.src}});
                },
                props: {
                    src: {type: String, required: true},
                },
            }
        },
        data() {
            return {
                defaultUserFace: "this.src='" + require( "@/assets/img/" + this._p_env.VUE_APP_RES_IMG_DEF_USER_FACE) + "'",
                isCollapse: false,
                isRefresh: true,
                activeTab: HOME_TAB,
                menuTabs: [],
                tabIndex: 1,
                // user: JSON.parse(window.sessionStorage.getItem("user"))
                isMchSys: false,
                isMchSysFirstOpen: true,
                clientHeight: '0',
                activeIndex: '1',
                activeIndex2: '1',
                menus: []
            }
        },
        created() {
            if (this.$router.currentRoute.path !== HOME_TAB) {
                this.$router.replace("/home")

                // F5刷新页面后，再加载一次菜单
                // this.initMenu(this.$router, this.$store)

            }

            this.isRefresh = false
            this.activeTab = HOME_TAB
            this.$nextTick(()=>{
                this.isRefresh = true
            })
        },
        mounted() {
            console.log("路由数量：" + this.$store.state.routes.length);

            if (this.user.type === this._enums.SysAccTypeEnum.商户.id) {
                this.isMchSys = true;
            } else {
                this.isMchSys = false;
            }

            // 初始化或刷新后重置 menuTabs HrInfo
            this.menuTabs = [{
                    title: '首页',
                    name: HOME_TAB,
                    icon: 'el-icon-s-home',
                    content: 'Tab 1 content'
                }]
            let curPath = this.$router.currentRoute.path
            if (curPath!==HOME_TAB) {
                this.$store.state.menus.forEach(item => {
                    if (item.path===curPath) {
                        this.menuTabs.push({
                            title: item.name,
                            name: item.path,
                            icon: item.icon
                        })
                    }
                })
                this.activeTab = curPath
            }

            // 获取浏览器可视区域高度
            this.clientHeight = `${document.documentElement.clientHeight}`;
            console.log("clientHeight:" + this.clientHeight);
            window.onresize = () => {
                this.clientHeight = `${document.documentElement.clientHeight}`;
                console.log("clientHeight onresize:" + this.clientHeight);
            };

            if (!this.isMchSys) {

                // 初始化设备型号
                this.getRequest(URL_DEV_MODELS).then(resp => {
                    if (resp) this.$root.g_data_dev_model = resp.data;
                });
                // 初始化行业基础信息
                this.getRequest(URL_DATA_MCH_BUSINESSCATEGORY).then(resp => {
                    if (resp) this.$root.g_data_business_category = resp.data;
                });
                // 初始化用户成本费率
                this.getRequest(URL_DATA_USER_BASE_PRORATE).then(resp => {
                    if (resp) {
                        this.$root.g_data_user_product_rate = resp.data;
                        console.log("g_data_user_product_rate", this.$root.g_data_user_product_rate)
                        this.$root.g_data_mini_rate = new MiniRate();
                        for (let iii = 0; iii < this.$root.g_data_user_product_rate.length; iii++) {
                            for (let jjj = 0; jjj < this.$root.g_data_user_product_rate[iii].payProductChannelList.length; jjj++) {
                                for (let kkk = 0; kkk < this.$root.g_data_user_product_rate[iii].payProductChannelList[jjj].userRateList.length; kkk++) {
                                    let userRate = this.$root.g_data_user_product_rate[iii].payProductChannelList[jjj].userRateList[kkk];
                                    this.$root.g_data_mini_rate.add(userRate.id, userRate.rate, userRate.fixRate, userRate.feeLowest, userRate.feeHighest,
                                        userRate.payChannelCode, userRate.payWayCode, userRate.payModeCode, userRate.rateType);
                                }
                            }
                        }
                        console.log("g_data_mini_rate", this.$root.g_data_mini_rate)
                    }
                });
            }


        },
        watch: {
            clientHeight: function () { // clientHeight值改变时触发
                this.changeFixed(this.clientHeight)
                console.log("watch changeFixed:" + this.clientHeight);
            }
            /*,
            activeTab: {
                immediate: true,
                handler(val, oldVal) {
                    console.log(val, oldVal, this.$router.currentRoute.path)

                    if (val && val!==oldVal && val!==this.$router.currentRoute.path) {
                        this.$router.push(val);
                    }
                }
            }*/
        },
        computed: {
            routes() {
                return this.$store.state.routes;
            },
            user() {
                return this.$store.state.currentHr;
            }
        },
        methods: {
            onCollapse() {
                this.isCollapse = !this.isCollapse
                console.log("isCollapse", this.isCollapse)
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            removeTab(targetName) {
                if (targetName==='/home') {
                    // tab-pane的close属性已动态定义此功能
                    console.log("HOME页禁止关闭")
                    return
                }
                console.log("TabArray Del", targetName)

                let tabs = this.menuTabs;
                let activeName = this.activeTab;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                activeName = nextTab.name;
                            }
                        }
                    });
                }

                this.activeTab = activeName;
                this.menuTabs = tabs.filter(tab => tab.name !== targetName);
                if (activeName!==this.$router.currentRoute.path) {
                    this.$router.replace(activeName);
                }
            },
            // tab 被选中时触发
            clickTab(target) {
                console.log("TAB-CLICK", target.name)
                if (target.name!==this.$router.currentRoute.path) {
                    this.$router.replace(target.name);
                }
                // this.$refs.refElMenu.open('2')
            },
            // 菜单激活回调 index: 选中菜单项的 index, indexPath: 选中菜单项的 index path
            // 示例： key /dev/basic ，keyPath ['2', '/dev/basic']
            // 当前router页已经通过菜单激活，不需要再打开，只要更新tab相关
            // 涉及Tab的更新： menuTabs 标签数组，activeTab 当前激活的标签页
            handleSelect2(key, keyPath) {
                console.log("MENU-CLICK", key, keyPath)
                // 如果当前菜单未存入标签数组内，则存入
                let menu = this.menuTabs.filter(e => e.name === key)
                if (menu.length===0) {
                    this.$store.state.menus.forEach(item => {
                        if (item.path===key) {
                            console.log("TabArray Add", key)
                            this.menuTabs.push({
                                title: item.name,
                                name: item.path,
                                icon: item.icon
                            })
                        }
                    })
                }
                this.activeTab = key
                if (this.activeTab!==this.$router.currentRoute.path) {
                    this.$router.replace(this.activeTab);
                }
            },
            handleSelect(key, keyPath) {
                console.log(key);
                console.log(keyPath);
                if (key === '1') {
                    this.isMchSysFirstOpen = true;
                    this.$router.replace("/home");
                } else if (key === '2-1') {
                    this.$router.push('/NormalSkd');
                    this.isMchSysFirstOpen = false;
                }  else if (key === '2-2') {
                    this.$router.push('/FixSkd');
                    this.isMchSysFirstOpen = false;
                } else if (key === '3-1') {
                    this.$router.push('/BillDetails');
                    this.isMchSysFirstOpen = false;
                } else if (key === '3-2') {
                    this.$router.push('/BillTotals');
                    this.isMchSysFirstOpen = false;
                } else if (key === '4-1') {
                    this.$router.push('/BillMchInfo');
                    this.isMchSysFirstOpen = false;
                } else if (key === '4-2') {
                    this.commandHandler('userinfo');
                    this.isMchSysFirstOpen = false;
                }
            },
            changeFixed(clientHeight) { // XUUYAOO 动态修改样式
                /*
                                this.$refs.homePage.$el.style.height = clientHeight-0+'px';
                                this.$refs.asideScrollbar.$el.style.height = clientHeight+'px';
                                this.$refs.rtView.$el.style.height = clientHeight-60-380+'px';
                */
            },
            goChat() {
                this.$router.push("/chat");
            },
            commandHandler(cmd) {
                if (cmd == 'logout') {
                    this.$confirm('此操作将注销登录, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.getRequest("/logout");
                        // this.getRequest("/logout?id=" + this.user.id);
                        window.sessionStorage.removeItem("user")
                        this.$store.commit('initRoutes', []);
                        this.$router.replace("/");
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消操作'
                        });
                    });
                } else if (cmd === 'userinfo') {
                    this.isMchSysFirstOpen = false;
                    let menu = this.menuTabs.filter(e => e.name === USER_TAB)
                    if (menu.length===0) {
                        this.menuTabs.push({
                            title: '个人中心',
                            name: USER_TAB,
                            icon: ''
                        })
                    }
                    this.activeTab = USER_TAB
                    if (this.activeTab!==this.$router.currentRoute.path) {
                        this.$router.replace(this.activeTab);
                    }
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .homeRouterView {
        margin-top: 10px;
        border: 0px solid red;
    }

    .homeWelcome {
        text-align: center;
        font-size: 30px;
        font-family: 微软雅黑;
        color: #409eff;
        padding-top: 50px;
    }

    .homeHeader {
        z-index: 999;
        position: relative;
        background-color: #4a5064;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /*padding: 0px 15px;*/
        box-sizing: border-box;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }

    .homeHeader .title {
        font-size: 25px;
        font-family: YouYuan;
        font-weight: normal;
        color: #ffffff;
    }

    .homeHeader .userInfo {
        cursor: pointer;
        font-size: 13px;
        font-family: "Microsoft YaHei";
        font-weight: normal;
        color: #E1E1E1;
    }

    .el-dropdown-link img {
        width: 48px;
        height: 48px;
        border-radius: 24px;
        margin-left: 8px;
    }

    .el-dropdown-link {
        display: flex;
        align-items: center;
    }

    .style-el-main {
    }

    .style-collapse {
        padding: 0 8px;
        height: 26px;
        line-height: 26px;
        background-color: white;
        font-size: 16px;
        margin: 0;
        border-bottom: 1px solid #d8dce5; /*去除标签下的横线*/
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
        cursor: pointer;
    }
    .style-collapse:hover {
        background: #42b983;
        color: white;
    }

    .layui-body-header-title {
        border-left: 4px solid #009688;
        padding-left: 6px;
    }

    .font10-c {
        font-size: 12px;
        transform: scale(0.7);
        transform-origin: center;
    }

    .cls-tab {
        :deep(.el-tabs__nav-wrap)  {
            margin-bottom: 0;
        }

        :deep(.el-tabs__header .el-tabs__item)  {
            border-bottom: 0;
        }

        :deep(.el-tabs__header)  {
            margin: 0;
            border-bottom: 1px solid #d8dce5; /*去除标签下的横线*/
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
        }
        :deep(.el-tabs__item)  {
            user-select: none;
            height: 25px;
            line-height: 25px;
            background-color: white;
            font-size: 12px;
        }
        :deep(.el-tabs__item:hover) {
            color: #42b983;
        }
        :deep(.el-tabs__item.is-active)  {
            color: white;
            background-color: #42b983;
        }
        :deep(.el-tabs__item .el-icon-close)  {
            right: -10px;
        }
        :deep(.el-tabs__nav-prev)  {
            left: 3px;
            line-height: 25px;
            font-weight: bolder;
            font-size: 16px;
            color: #42b983;
        }
        :deep(.el-tabs__nav-next)  {
            right: 3px;
            line-height: 25px;
            font-weight: bolder;
            font-size: 16px;
            color: #42b983;
        }
    }

</style>
